/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable prefer-const */
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { Calendar } from 'react-date-range';
import TWLocale from 'date-fns/locale/zh-TW';
import datetimeobj from 'date-and-time';
// material
import {
  Button,
  Grid,
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Typography,
  Box,
  Stack,
  Container,
  Snackbar,
  TextField,
} from '@mui/material';
import L from "leaflet";

import MuiAlert from '@mui/material/Alert';
import Page from '../components/Page';
import Gridtable from '../components/gridtable';
// eslint-disable-next-line import/named

import ServiceStatisticsDownload from '../components/ServiceStatisticsDownload';
import VehicleMap from '../components/Map/VehicleMap';
import AbnormalGPSPanel from '../components/Vehicle/AbnormalGPSPanel';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '.css-12wq9jj-MuiPaper-root-MuiDialog-paper': {
    width: '100%',
    height: '100%'
  }
}));
const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
// 定義切換頁
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
//  Create the Icon
const LeafIcon = L.Icon.extend({
  options: {}
});
let centergps = [24.050666, 120.483982];
if (localStorage.getItem('Longitude') != null)
  centergps = [parseFloat(localStorage.getItem('Latitude')), parseFloat(localStorage.getItem('Longitude'))];


// eslint-disable-next-line one-var
const blueIcon = new LeafIcon({
  iconUrl: '../favicon/blue.png'
}),
  greenIcon = new LeafIcon({
    iconUrl: '../favicon/green.png'
  }),
  PurpleIcon = new LeafIcon({
    iconUrl: '../favicon/Purple.png'
  }),
  redIcon = new LeafIcon({
    iconUrl: '../favicon/red.png'
  }),
  yellowIcon = new LeafIcon({
    iconUrl: '../favicon/yellow.png'
  }),
  warningIcon = new LeafIcon({
    iconUrl: '../favicon/warning.png'
  }),
  blackIcon = new LeafIcon({
    iconUrl: '../favicon/black.png'
  });
// -----------------按鈕-------------
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

const OmniEyescar = ['AKZ-3312', 'BJX-7010', 'AUX-1013', 'BXJ-7011', 'BLE-3821', 'BPA-6013', 'BJX-7013', 'AKK-9213', 'ALB-2973', 'BGA-7731'];
export default function EnhancedTable() {

  const abnormalGPSheadCell = [
    {
      id: 'Identifier',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '車牌'
    },
    {
      id: 'FK_UnitID',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '車機號碼'
    },
    {
      id: 'message',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '訊息說明'
    },
    {
      id: 'time',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '發生時間'
    }
  ];

  // 宣告一個新的 state 變數，我們稱作為「count」。
  // 相似於 componentDidMount 和 componentDidUpdate:
  const Region = localStorage.getItem('region');
  const host = localStorage.getItem('apiurl');
  const [openmap, setopenmap] = useState(null);
  // 車機清單
  const [realtimeButtonopen, setrealtimeButtonopen] = React.useState(false);
  const [Vehiclelist, setVehiclelist] = React.useState([]);
  const [abnormalGPSVehiclelist, setabnormalGPSVehiclelist] = React.useState([]);
  const [Vehiclelist1, setVehiclelist1] = React.useState([]);
  const [Vehiclflaglist, setVehiclflaglist] = React.useState([]);
  const [a1a2list, seta1a2list] = React.useState([]);
  const [reason, setreason] = React.useState(' ');
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [Buttonopen, setButtonopen] = React.useState(false);
  const [carno, setcarno] = React.useState('');
  const [abnormalGPSheadCells, setabnormalGPSheadCells] = useState([]);
  const [realtime, setrealtime] = React.useState({ vehicle: '', event_video_url: '', Latitude: 24.050666, Longitude: 120.483982 });
  // ------------------rtsp-----------------------//
  const [rtsprealtimeButtonopen, setrtsprealtimeButtonopen] = React.useState(false);
  const [rtsprealtime, setrtsprealtime] = React.useState({ vehicle: '', event_video_url: '', Latitude: 24.050666, Longitude: 120.483982 });
  const streamName = React.useRef();
  const SDP_URL = React.useRef();

  const [bindlist, setbindlist] = React.useState([]);
  const [bindCells, setbindCells] = useState([]);
  const [checked, setChecked] = React.useState([]);
  const checkedcurrent = useRef([]);
  const pagesize = useRef(0);
  const [platevalue, setplatevalue] = React.useState('');
  const channelName = React.useRef();
  const accessKeyId = React.useRef();
  const secretAccessKey = React.useRef();
  const [unbindButtonopen, setunbindButtonopen] = React.useState(false);

  const [abnormalGPSdate, setabnormalGPSdate] = useState(new Date());


  const [personid, setpersonid] = useState("");

  const unbindButtonclick = async () => {
    await axios
      .delete(`${host}/api/line/unbind/${personid}?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // 呼叫解除綁定api
          alert('解除綁定成功');
          setunbindButtonopen(false);
          getlinebindlist();
        } else {
          setreason(response.data.message);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });

  };
  const unbindButtonhandleChange = (id) => {
    setpersonid(id);
  };

  const unbindButtonhandleClickOpen = () => {
    setunbindButtonopen(true);
  };
  const unbindButtonhandleClickClose = () => {

    setunbindButtonopen(false);
  };

  // eslint-disable-next-line prefer-const
  let intervalId = null;
  useEffect(() => {
    // 定義一個 async 函式來處理非同步邏輯
    const fetchData = async () => {
      await getVehicle();
      await getabnormalGPSVehicle(abnormalGPSdate);
      await Vehicle_management();
      await getlinebindlist();
      await setabnormalGPSheadCells(abnormalGPSheadCell);
      await geta1a2dbscan();
    };
  
    fetchData();
  
    // 設定定時器
    const intervalId = setInterval(async () => {
      await Vehicle_management();
      await getabnormalGPSVehicle(abnormalGPSdate);
    }, 120000);
  
    // 清除定時器的 cleanup 函式，必須是同步函式
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  



  // eslint-disable-next-line camelcase
  const getlinebindlist = async () => {
    // eslint-disable-next-line prefer-const
    let workheadCell = [
      {
        name: 'ID',
        title: '綁定帳號'
      },
      {
        name: 'lineid',
        title: '綁定lineid'
      },
      {
        name: 'NAME',
        title: '綁定名字'
      },
      {
        name: 'Role',
        title: '身份'
      }
      ,
      {
        name: 'region',
        title: '綁定地區'
      },
      {
        name: 'time',
        title: '綁定時間'
      }

    ];
    await setbindCells(workheadCell);
    await axios
      .get(
        // eslint-disable-next-line no-undef
        `${host}/api/line/getBindlist?Region=${Region}`
      )
      .then((response) => {
        // handle success
        if (response.data.code == 0) {

          setbindlist(response.data.data);
        }

      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  // 讀取a1a2清單
  // eslint-disable-next-line camelcase
  const geta1a2dbscan = async () => {
    await axios
      .get(`${host}/api/car/geta1a2dbscan?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          await seta1a2list([]);
          await seta1a2list(response.data.data);
        } else {
          setreason(response.data.message);
          seta1a2list([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
    // setOpen(true);
  };

  const dateTonetcoreStrTime = (datetime, mode) => {
    let returnstr = "";
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD');
    } else {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD HH:mm:ss');

    }
    return returnstr;
  };

  // 讀取壞掉車機清單
  // eslint-disable-next-line camelcase
  const getabnormalGPSVehicle = async (tempdate) => {

    let tempgetabnormalGPSdate = await dateTonetcoreStrTime(tempdate, 0);

    await axios
      .get(`${host}/api/car/getabnormal_GPS?Region=${Region}&Date=${tempgetabnormalGPSdate}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          await setabnormalGPSVehiclelist(response.data.data);

        } else {
          setreason(response.data.message);
          setabnormalGPSVehiclelist([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  }
  // 讀取車機清單
  // eslint-disable-next-line camelcase
  const getVehicle = async () => {
    await axios
      .get(`${host}/api/car/getcar?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // handle success
          // eslint-disable-next-line prefer-const
          let resArr = [];
          const set = new Set(response.data.data);
          resArr = Array.from(set);

          pagesize.current = Math.ceil((resArr.length / 4));
          // 一開始將所有車輛加入list
          let newChecked = [];

          for (let i = 0; i < resArr.length; i++) {
            newChecked.push(resArr[i].CAR_ID);
          }

          checkedcurrent.current = newChecked;
          await setChecked(newChecked);


          await setVehiclflaglist(resArr);

        } else {
          setreason(response.data.message);
          setVehiclflaglist([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  }
  // 讀取車機清單
  // eslint-disable-next-line camelcase
  const Vehicle_management = async () => {
    await axios
      .get(`${host}/api/car/getcar?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // handle success
          // eslint-disable-next-line prefer-const
          let resArr = [];
          let Vehiclelistchecked = [];
          //   let regioncarlabel = [];
          // let tempgroupByregioncar = [];
          const set = new Set(response.data.data);
          resArr = Array.from(set);


          for (let i = 0; i < resArr.length; i++) {
            resArr[i].label = resArr[i].CAR_NO;
            if (checkedcurrent.current.indexOf(resArr[i].CAR_ID) != -1) {
              Vehiclelistchecked.push(resArr[i]);
            }


          }

          await setVehiclelist1([]);
          await setVehiclelist1(Vehiclelistchecked);
          await setVehiclelist([]);
          await setVehiclelist(resArr);
          // tempgroupByregioncar = await resArr.groupBy('region');
          // regioncarlabel = await Object.keys(tempgroupByregioncar);
          // await setgroupByregioncar(tempgroupByregioncar);
          // await setgroupByregioncarlabel(regioncarlabel);
        } else {
          setreason(response.data.message);
          setVehiclelist([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };

  // 關閉彈跳釋出
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  // tab切換
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const rtspRealtimehandleClose = async () => {
    setrtsprealtimeButtonopen(false);
  };
  const realtimeButtonhandleClose = async () => {
    // deletechannel
    await axios
      .delete(`${host}/api/DVR/Deletestreaming_connection?camera_channel=${channelName.current}`)
      .then(async (response) => {

        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setrealtimeButtonopen(false);
        } else {
          setrealtimeButtonopen(false);
          setreason(response.data.message);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });

  };
  const rtspRealtimeButtonopen = async (carobj, channel) => {

    // get channelName
    await axios
      .post(`${host}/api/DVR/GetCarLiveStream?vehicle=${carobj.CAR_NO}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          if (response.data.data.length > 0) {

            streamName.current = response.data.data[channel].Web_RTC.StreamName;
            console.log(response.data.data);
            SDP_URL.current = response.data.data[channel].Web_RTC.URL;
            await setrtsprealtimeButtonopen(true);
            await setrtsprealtime(carobj);
          }

        } else {
          setreason(response.data.message);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });


  };

  const realtimeButtonClickOpen = async (carobj, camerachannel) => {
    // get channelName
    await axios
      .post(`${host}/api/DVR/streaming_connection?vehicle=${carobj.CAR_NO}&camera_channel=${camerachannel}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          console.log(response.data.data.accesskey);
          channelName.current = response.data.data.channel_name;
          accessKeyId.current = response.data.data.acceskeyid;
          secretAccessKey.current = response.data.data.accesskey;
          await setrealtimeButtonopen(true);
          await setrealtime(carobj);
        } else {
          setreason(response.data.message);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });


  };
  const [outlineColour, fillColour, transparency] = ['red', '#FF5151', 0.2];
  return (
    <Page title="營運資訊 | 智慧城市營運平台">
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            {reason}
          </Alert>
        </Snackbar>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="FLEET WEB" {...a11yProps(0)} />
          <Tab label="綁定資訊" {...a11yProps(1)} />
          <Tab label="下載line@服務統計數據" {...a11yProps(2)} />
          <Tab label="車機位置異常列表" {...a11yProps(3)} />

        </Tabs>
        <TabPanel value={value} index={0} >
          <Grid item xs={7}>
            <Stack spacing={2}>
              <VehicleMap
                centergps={centergps}
                setopenmap={setopenmap}
                Vehiclelist1={Vehiclelist1}
                Region={Region}
                OmniEyescar={OmniEyescar}
                a1a2list={a1a2list}
                outlineColour={outlineColour}
                fillColour={fillColour}
                transparency={transparency}
                icons={{
                  greenIcon,
                  blackIcon,
                  yellowIcon,
                  redIcon,
                  PurpleIcon,
                  blueIcon,
                  warningIcon
                }}
              />
            </Stack>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <Gridtable bindlist={bindlist} headCells={bindCells} filename="綁定表" />
            </Grid>
            <Grid item xs={2}>
              <Button variant="contained" onClick={() => unbindButtonhandleClickOpen()}>強制解除綁定</Button>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ServiceStatisticsDownload />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Stack spacing={2}>
            <Grid container spacing={2}>
              <AbnormalGPSPanel
                getabnormalGPSVehicle={getabnormalGPSVehicle}
                setabnormalGPSdate={setabnormalGPSdate}
                abnormalGPSdate={abnormalGPSdate}
                abnormalGPSVehiclelist={abnormalGPSVehiclelist}
                abnormalGPSheadCells={abnormalGPSheadCells}
                TWLocale={TWLocale}
              />
            </Grid>
          </Stack>
        </TabPanel>

      </Container>

      <BootstrapDialog
        onClose={unbindButtonhandleClickClose}
        aria-labelledby="customized-dialog-title"
        open={unbindButtonopen}
        minWidth="md"
        maxWidth="md"
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={unbindButtonhandleClickClose}>
          強制解除綁定
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Typography variant="subtitle1" gutterBottom component="div">
                輸入強制解除綁定ID
              </Typography>
              <TextField
                required
                id="outlined-required"
                label="乘客ID"
                defaultValue=""
                value={personid}
                onChange={async (event) => {
                  const value1 = event.target.value;
                  await unbindButtonhandleChange(value1);

                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Button variant="contained" onClick={() => unbindButtonclick()}>解除綁定</Button>
            </Grid>
          </Grid>
        </DialogContent>
      </BootstrapDialog>


    </Page>

  );
}
